"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _SubNavHeading = require("@ccw-pwa-ui/SubNavHeading");
var _StoreInformationTile = require("@ccw-pwa-ui/StoreInformationTile");
var _Modal = require("@ccw-pwa-ui/Modal");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
require("../styles/DispatcherStoreDashboard.css");
var _WhatYourNeedModal = _interopRequireDefault(require("./WhatYourNeedModal"));
var _SystemGatewayComponent = _interopRequireDefault(require("./SystemGatewayComponent"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("@ccw-pwa-ui/Button");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
const TechDispatcherComponent = _ref => {
  let {
    heading,
    subHeading,
    handleBack,
    string,
    name,
    address,
    Organization,
    headerText,
    btnTitle,
    separator,
    loginType,
    navigateToAddSystem,
    navigateToAddHub,
    handleModal,
    openModal,
    positiveActionButtonTitle,
    whatYourNeedContentArray,
    modalHeaderText,
    modalTopContent,
    systems,
    gateways,
    data,
    onclick,
    onPartialClick,
    gateLoading,
    sysLoading,
    systemType,
    gatewayType,
    waterDestinationItem,
    rightButtonShow,
    successLabel,
    everythingOkIcon,
    optionBtnClick,
    storeAlertList,
    onDetailsTileClick,
    isLoading,
    isDisable,
    rightArrowBtn,
    everythingOkText,
    isSystem,
    statusIcon,
    statusText,
    dscIcon,
    partialLogo,
    deleteLogo,
    onPartialDelete,
    deleteModal,
    warningSystemModalData,
    openErrorModal,
    popUpShow,
    popUpStatusIcon,
    popUpStatusText,
    systemsText,
    systemsLabelText,
    displayZoomImage,
    storeImage,
    crossIconAction,
    imageLoading,
    zoomImageAction,
    storeImageStyle,
    userScreenPref
  } = _ref;
  const getSystemDetailsSubComponent = () => {
    return systems.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, rightArrowBtn && /*#__PURE__*/_react.default.createElement("div", {
      className: "hubsystem-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "system-btn-div",
      "data-testid": "system-btn-div",
      onClick: () => navigateToAddSystem()
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
      src: _index.default.plusStoreIcon.default,
      alt: "plus"
    })), /*#__PURE__*/_react.default.createElement("span", null, "System"))), sysLoading ? "" : /*#__PURE__*/_react.default.createElement("div", {
      className: "systems-text"
    }, systemsText), /*#__PURE__*/_react.default.createElement(_SystemGatewayComponent.default, {
      systemType: systemType,
      onclick: onclick,
      onPartialClick: onPartialClick,
      onPartialDelete: onPartialDelete,
      gateways: gateways,
      gatewayType: gatewayType,
      systems: systems,
      gatewayName: "Gateway",
      waterDestinationItem: waterDestinationItem,
      optionBtnClick: optionBtnClick,
      rightArrowBtn: rightArrowBtn,
      isDisable: isDisable,
      everythingOkText: everythingOkText,
      statusIcon: statusIcon,
      statusText: statusText,
      dscIcon: dscIcon,
      partialLogo: partialLogo,
      deleteLogo: deleteLogo
    })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "systems-text"
    }, systemsText, " "), /*#__PURE__*/_react.default.createElement("div", {
      className: "techDispatcher-mainHeading"
    }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
      variant: "header-text",
      headerText: headerText
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "techDispatcher-imagediv"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _index.default.dispatcherFirstVisit.default,
      alt: "tech Dashboard"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "techDispatcher-subHeading"
    }, string.SUB_HEADING), /*#__PURE__*/_react.default.createElement("div", {
      className: "techDispatcher-subContent"
    }, string.SUB_CONTENT), /*#__PURE__*/_react.default.createElement("div", {
      className: "techDispatcher-bottomContent",
      "data-testid": "techDispatcher-bottomContent",
      onClick: () => handleModal(!openModal)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "me-2"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _index.default.questionIcon.default,
      alt: ""
    })), string.BOTTOM_CONTENT), rightArrowBtn && /*#__PURE__*/_react.default.createElement("div", {
      className: "techDispatcher-button",
      "data-testid": "navigate-to-addsystem"
    }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
      variant: "primary-long",
      title: btnTitle,
      onClick: () => navigateToAddSystem()
    })));
  };
  const getStoreTileComponent = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "techDispatcher-body"
    }, sysLoading || imageLoading ? /*#__PURE__*/_react.default.createElement("div", {
      className: "spinner-wrapper",
      style: {
        zIndex: 9999
      }
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
      animation: "border"
    })) : /*#__PURE__*/_react.default.createElement("div", {
      className: "store-image-div",
      onClick: zoomImageAction
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "store-image-img",
      src: storeImage,
      alt: "",
      style: storeImageStyle,
      onClick: zoomImageAction,
      "data-testid": "store-image-div"
    })), storeAlertList !== null && storeAlertList !== void 0 && storeAlertList.length ? /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "storeDetailTile"
    }, " ", /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
      name: name,
      address: address,
      arrowImage: _index.default.ArrowRight.default,
      Organization: Organization,
      loginType: loginType,
      rightButtonShow: rightButtonShow,
      successLabel: successLabel,
      everythingOkIcon: everythingOkIcon,
      storeAlertList: storeAlertList,
      handleBack: handleBack,
      onClick: onDetailsTileClick,
      isDisable: isDisable,
      isSystem: isSystem
    })) : /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "storeDetailTile"
    }, " ", /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
      name: name,
      Organization: Organization,
      arrowImage: _index.default.ArrowRight.default,
      address: address,
      rightButtonShow: rightButtonShow,
      loginType: loginType,
      everythingOkIcon: everythingOkIcon,
      successLabel: successLabel,
      onClick: onDetailsTileClick,
      handleBack: handleBack,
      isDisable: isDisable,
      isSystem: isSystem
    })), sysLoading ? null : getSystemDetailsSubComponent());
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "techDispatcher-wrapper"
  }, popUpShow && !isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "popupState"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "popUpShow"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "popUpImage"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "statusImg"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: popUpStatusIcon,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "statusText"
  }, popUpStatusText))), /*#__PURE__*/_react.default.createElement(_SubNavHeading.SubNavHeading, {
    heading: heading,
    subHeading: subHeading,
    separator: separator
  }), /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: userScreenPref && sessionStorage.getItem("Dispatcher_Web_Mobile_View") ? string.NAV_HEADING_CONTENT_WEB_VIEW : string.NAV_HEADING_CONTENT,
    handleBack: handleBack,
    leftArrowImage: _index.default.leftArrow.default
  }), sysLoading ? null : getStoreTileComponent(), openModal ? /*#__PURE__*/_react.default.createElement(_WhatYourNeedModal.default, {
    handleModal: handleModal,
    openModal: openModal,
    positiveActionButtonTitle: positiveActionButtonTitle,
    whatYourNeedContentArray: whatYourNeedContentArray,
    modalHeaderText: modalHeaderText,
    modalTopContent: modalTopContent
  }) : "", (deleteModal || openErrorModal) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.displayModal,
    modalHeaderText: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderText,
    modalHeaderTextStyle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderTextStyle,
    modalDetailText: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalDetailText,
    modalHeaderIcon: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderIcon,
    displayCrossIcon: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.displayCrossIcon,
    variant: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.variant,
    positiveActionButtonTitle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.positiveActionButtonTitle,
    positiveAction: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.positiveAction,
    negativeButtonActionTitle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.negativeButtonActionTitle,
    crossIconAction: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.crossIconAction,
    negativeAvtion: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.negativeAction
  }))), isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper",
    style: {
      zIndex: 9999
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })), displayZoomImage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "image-zoom-modal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    visible: true,
    variant: "mobile-screen-zoom",
    displayModal: displayZoomImage,
    imageVariant: "zoom-image",
    zoomImageSrc: storeImage,
    displayCrossIcon: true,
    crossIconAction: crossIconAction
  })) : null);
};
var _default = exports.default = TechDispatcherComponent;